module.exports = __webpack_public_path__ + "media/arrows/arrow-blue-a493334b.svg";